import { WixClient } from '@wix/sdk';
import {
  CreateMessageStreamRequest,
  CreateMessageStreamResponse,
} from '@wix/ambassador-innovation-widget-v1-message/types';

export const createMessageStream = (wixClient: WixClient) =>
  async function* (
    request: CreateMessageStreamRequest,
  ): AsyncGenerator<CreateMessageStreamResponse[], void, void> {
    const response = await wixClient.fetchWithAuth(
      '/wix-assistant-widget/v1/messages/stream',
      {
        method: 'post',
        headers: {
          Accept: 'application/x-ndjson',
        },
        body: JSON.stringify(request),
      },
    );
    const reader = response.body?.getReader();

    if (!reader) {
      throw new Error(`Failed to acquire reader for $response`);
    }

    const decoder = new TextDecoder();
    let text = '';
    let processed = 0;
    for (;;) {
      const { value, done } = await reader.read();
      if (done) {
        return;
      }

      const chunk = decoder.decode(value, { stream: true });
      text += chunk;
      const responses = tryParse(text);
      if (responses.length === 0) {
        // in unlikely event that first chunk is
        // not a full json item wait for the next chunk
        continue;
      }
      const newData = responses.slice(processed);
      processed = responses.length;
      yield newData;
    }
  };

const tryParse = (text: string): CreateMessageStreamResponse[] =>
  text
    .trimEnd()
    .split('\n')
    .reduce<CreateMessageStreamResponse[]>((acc, line) => {
      try {
        const item = JSON.parse(line);
        acc.push(item);
      } catch (e) {
        // unparsed line is most likely a partial chunk
        // that will be received later
      }

      return acc;
    }, []);
